import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CustomHeader } from "../components/AuthHeader";
import { CustomButton } from "../components/CustomButton";
import { useAuthStore } from "../features/auth/authStore";
import { useToast } from "../components/ToastProvider";
import { ArrowLeft, ChevronRight } from "lucide-react";
import rushLogo from "../assets/png/rush-logo.png";

export default function PhoneLoginScreen() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { verifyPhone, isLoading } = useAuthStore();
  const [phone, setPhone] = useState("");

  const handleSendOtp = async () => {
    const cleanedPhone = phone.trim();

    if (!cleanedPhone) {
      showToast("Please enter mobile number", "error");
      return;
    }

    try {
      await verifyPhone(cleanedPhone);
      // showToast("OTP sent successfully", "success");
      navigate("/verify", {
        state: { phone: cleanedPhone, intent: "login" },
      });
    } catch (error: any) {
      const message = error?.message || "Failed to send OTP";
      showToast(message, "error");
    }
  };

  return (
    <div className="flex flex-col min-h-screen pt-4 bg-white px-6 pb-10">
      <div className="sticky top-0 z-50 bg-white/90 backdrop-blur-md -mx-6 px-6 pt-4 pb-4 mb-2 flex items-center justify-between">
        <button
          onClick={() => navigate(-1)}
          className="w-11 h-11 border border-gray-100 rounded-2xl flex items-center justify-center active:scale-95 transition-transform shadow-sm bg-white"
        >
          <ArrowLeft size={20} className="text-gray-700" />
        </button>

        <img src={rushLogo} alt="Rush Logo" className="h-7 w-auto object-contain" />
      </div>

      {/* Header Text */}
      <CustomHeader
        title="Login with Mobile"
        subtitle="Enter your mobile number to receive a 4-digit OTP code."
      />

      {/* Form Area */}
      <div className="mt-8 flex-1">
        <form
          onSubmit={(event) => {
            event.preventDefault();
            void handleSendOtp();
          }}
        >
          <label className="text-xs font-bold text-gray-400 uppercase tracking-wider ml-1 mb-2 block">
            Mobile Number
          </label>
          <div className="relative">
            <input
              type="tel"
              placeholder="Enter mobile number"
              value={phone}
              onChange={(event) => setPhone(event.target.value)}
              disabled={isLoading}
              className="w-full h-14 bg-gray-50 border border-gray-100 rounded-2xl px-5 text-gray-800 outline-none focus:border-[#23A9C6] focus:bg-white transition-all disabled:opacity-50"
            />
          </div>
        </form>

        <div className="mt-6">
          <button
            onClick={() => navigate("/login")}
            className="text-[#23A9C6] text-sm font-bold flex items-center gap-1 hover:underline"
          >
            Prefer email login? <ChevronRight size={16} />
          </button>
        </div>

        {/* Action Footer - Now nested right after the link for a compact feel */}
        <div className="mt-10 space-y-6">
          <div className="text-center text-sm text-gray-500 animate-in fade-in slide-in-from-bottom-2">
            Don’t have an account?{" "}
            <button
              onClick={() => navigate("/signup")}
              className="text-[#23A9C6] font-bold transition-all hover:text-[#1A7C92]"
            >
              Sign up
            </button>
          </div>

          <CustomButton
            variant="primary"
            disabled={isLoading}
            onClick={() => void handleSendOtp()}
            className="w-full h-14 text-lg rounded-2xl font-bold flex items-center justify-center gap-3 active:scale-[0.98] transition-transform shadow-lg shadow-cyan-100"
          >
            {isLoading ? (
              <>
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                <span>Sending OTP...</span>
              </>
            ) : (
              <span>Send OTP</span>
            )}
          </CustomButton>
        </div>
      </div>
    </div>
  );
}